import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2" }

import { ref, watch, reactive, provide, computed } from "vue";
import {
  DestinyMatrix,
  DestinyMatrixKeysEnum,
  PREMIUM_KEYS_SET,
} from "@/types/destinyMatrix";
import { getMatrixDescription } from "@/api/destinyMatrix";
import EmptyModal from "@/components/modals/EmptyModal.vue";
import PersonalDataAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/PersonalDataAccordion.vue";
import FamilyPowerAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/FamilyPowerAccordion.vue";
import PointOfSpiritComfortAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/PointOfSpiritComfortAccordion.vue";
import SelfRealizationAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/SelfRealizationAccordion.vue";
import VacationAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/VacationAccordion.vue";
import AlcoholProneAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/AlcoholProneAccordion.vue";
import KarmaAndFortyYearsTasksAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/KarmaAndFortyYearsTasksAccordion.vue";
import PurposesAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/PurposesAccordion.vue";
import SpiritKarmaAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/SpiritKarmaAccordion.vue";
import ChildParentsKarmaAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/ChildParentsKarmaAccordion.vue";
import FamilyTasksSevenGenerationAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/FamilyTasksSevenGenerationAccordion.vue";
import ExcessWeightAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/ExcessWeightAccordion.vue";
import GettingReachByBirthYearAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/GettingReachByBirthYearAccordion.vue";
import MoneyInMatrixAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/MoneyInMatrixAccordion.vue";
import PersonalPointOfPowerAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/PersonalPointOfPowerAccordion.vue";
import PrevLifesTasksAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/PrevLifesTasksAccordion.vue";
import RelationsInMatrixAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/RelationsInMatrixAccordion.vue";
import WhatGivesYouResourceAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/WhatGivesYouResourceAccordion.vue";
import WhomWorksForSoulAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/WhomWorksForSoulAccordion.vue";
import RequirePremiumModal from "@/views/Calculators/DestinyMatrix/components/RequirePremiumModal.vue";
import HealthMapAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/HealthMapAccordion.vue";
import ProgramsAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/ProgramsAccordion.vue";
import YearTasksAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/YearTasksAccordion.vue";
import PredispositionToDiseasesAccordion from "@/views/Calculators/DestinyMatrix/components/accordions/PredispositionToDiseasesAccordion.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'MatrixDescriptionComponent',
  props: {
    matrix: {},
    submittedDate: {},
    userHasPremiumAccess: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const waitApiCall = ref(false);
const showRequirePremiumModal = ref(false);

const modalDate = computed(() => {
  return props.submittedDate.replaceAll("-", ".");
});

const accordionStates = reactive({
  personal: false,
  family: false,
  realization: false,
  comfort: false,
  vacation: false,
  alcoholProne: false,
  childParentsKarma: false,
  familyTasksSevenGeneration: false,
  excessWeight: false,
  gettingReachByYear: false,
  karmaAndFortyYearsTasks: false,
  moneyInMatrix: false,
  personalPointOfPower: false,
  previousLifesTasks: false,
  purpose: false,
  relationsInMatrix: false,
  spiritKarma: false,
  whatGivesYouResource: false,
  whomWorksForSoul: false,
  healthMap: false,
  programs: false,
  yeasTasks: false,
  predispositionToDiseases: false,
});

watch(
  () => props.matrix,
  () => {
    closeAllAccordions();
  }
);

function closeAllAccordions() {
  Object.keys(accordionStates).forEach((key) => {
    accordionStates[key as keyof typeof accordionStates] = false;
  });
}

async function getDescription(key: DestinyMatrixKeysEnum) {
  if (PREMIUM_KEYS_SET.has(key) && !props.userHasPremiumAccess) {
    showRequirePremiumModal.value = true;
    return;
  }

  try {
    waitApiCall.value = true;
    const apiDate = props.submittedDate.split("-").reverse().join("-");
    return await getMatrixDescription(key, apiDate);
  } catch (error) {
    console.error(error);
  } finally {
    waitApiCall.value = false;
  }
}

provide("getDescription", getDescription);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PersonalDataAccordion, {
      matrix: __props.matrix,
      modelValue: accordionStates.personal,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((accordionStates.personal) = $event))
    }, null, 8, ["matrix", "modelValue"]),
    _createVNode(FamilyPowerAccordion, {
      matrix: __props.matrix,
      modelValue: accordionStates.family,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((accordionStates.family) = $event))
    }, null, 8, ["matrix", "modelValue"]),
    _createVNode(PointOfSpiritComfortAccordion, {
      matrix: __props.matrix,
      modelValue: accordionStates.comfort,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((accordionStates.comfort) = $event))
    }, null, 8, ["matrix", "modelValue"]),
    _createVNode(SelfRealizationAccordion, {
      matrix: __props.matrix,
      modelValue: accordionStates.realization,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((accordionStates.realization) = $event))
    }, null, 8, ["matrix", "modelValue"]),
    _createVNode(VacationAccordion, {
      matrix: __props.matrix,
      modelValue: accordionStates.vacation,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((accordionStates.vacation) = $event))
    }, null, 8, ["matrix", "modelValue"]),
    _createVNode(YearTasksAccordion, {
      matrix: __props.matrix,
      modelValue: accordionStates.yeasTasks,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((accordionStates.yeasTasks) = $event))
    }, null, 8, ["matrix", "modelValue"]),
    _createVNode(AlcoholProneAccordion, {
      matrix: __props.matrix,
      hasPremiumAccess: __props.userHasPremiumAccess,
      modelValue: accordionStates.alcoholProne,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((accordionStates.alcoholProne) = $event))
    }, null, 8, ["matrix", "hasPremiumAccess", "modelValue"]),
    _createVNode(ChildParentsKarmaAccordion, {
      matrix: __props.matrix,
      hasPremiumAccess: __props.userHasPremiumAccess,
      modelValue: accordionStates.childParentsKarma,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((accordionStates.childParentsKarma) = $event))
    }, null, 8, ["matrix", "hasPremiumAccess", "modelValue"]),
    _createVNode(FamilyTasksSevenGenerationAccordion, {
      matrix: __props.matrix,
      hasPremiumAccess: __props.userHasPremiumAccess,
      modelValue: accordionStates.familyTasksSevenGeneration,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((accordionStates.familyTasksSevenGeneration) = $event))
    }, null, 8, ["matrix", "hasPremiumAccess", "modelValue"]),
    _createVNode(ExcessWeightAccordion, {
      matrix: __props.matrix,
      hasPremiumAccess: __props.userHasPremiumAccess,
      modelValue: accordionStates.excessWeight,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((accordionStates.excessWeight) = $event))
    }, null, 8, ["matrix", "hasPremiumAccess", "modelValue"]),
    _createVNode(GettingReachByBirthYearAccordion, {
      matrix: __props.matrix,
      hasPremiumAccess: __props.userHasPremiumAccess,
      modelValue: accordionStates.gettingReachByYear,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((accordionStates.gettingReachByYear) = $event))
    }, null, 8, ["matrix", "hasPremiumAccess", "modelValue"]),
    _createVNode(KarmaAndFortyYearsTasksAccordion, {
      matrix: __props.matrix,
      hasPremiumAccess: __props.userHasPremiumAccess,
      modelValue: accordionStates.karmaAndFortyYearsTasks,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((accordionStates.karmaAndFortyYearsTasks) = $event))
    }, null, 8, ["matrix", "hasPremiumAccess", "modelValue"]),
    _createVNode(MoneyInMatrixAccordion, {
      matrix: __props.matrix,
      hasPremiumAccess: __props.userHasPremiumAccess,
      modelValue: accordionStates.moneyInMatrix,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((accordionStates.moneyInMatrix) = $event))
    }, null, 8, ["matrix", "hasPremiumAccess", "modelValue"]),
    _createVNode(PersonalPointOfPowerAccordion, {
      matrix: __props.matrix,
      hasPremiumAccess: __props.userHasPremiumAccess,
      modelValue: accordionStates.personalPointOfPower,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((accordionStates.personalPointOfPower) = $event))
    }, null, 8, ["matrix", "hasPremiumAccess", "modelValue"]),
    _createVNode(PrevLifesTasksAccordion, {
      matrix: __props.matrix,
      hasPremiumAccess: __props.userHasPremiumAccess,
      modelValue: accordionStates.previousLifesTasks,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((accordionStates.previousLifesTasks) = $event))
    }, null, 8, ["matrix", "hasPremiumAccess", "modelValue"]),
    _createVNode(PurposesAccordion, {
      matrix: __props.matrix,
      hasPremiumAccess: __props.userHasPremiumAccess,
      modelValue: accordionStates.purpose,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((accordionStates.purpose) = $event))
    }, null, 8, ["matrix", "hasPremiumAccess", "modelValue"]),
    _createVNode(RelationsInMatrixAccordion, {
      matrix: __props.matrix,
      hasPremiumAccess: __props.userHasPremiumAccess,
      modelValue: accordionStates.relationsInMatrix,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((accordionStates.relationsInMatrix) = $event))
    }, null, 8, ["matrix", "hasPremiumAccess", "modelValue"]),
    _createVNode(SpiritKarmaAccordion, {
      matrix: __props.matrix,
      hasPremiumAccess: __props.userHasPremiumAccess,
      modelValue: accordionStates.spiritKarma,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((accordionStates.spiritKarma) = $event))
    }, null, 8, ["matrix", "hasPremiumAccess", "modelValue"]),
    _createVNode(WhatGivesYouResourceAccordion, {
      matrix: __props.matrix,
      hasPremiumAccess: __props.userHasPremiumAccess,
      modelValue: accordionStates.whatGivesYouResource,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((accordionStates.whatGivesYouResource) = $event))
    }, null, 8, ["matrix", "hasPremiumAccess", "modelValue"]),
    _createVNode(WhomWorksForSoulAccordion, {
      matrix: __props.matrix,
      hasPremiumAccess: __props.userHasPremiumAccess,
      modelValue: accordionStates.whomWorksForSoul,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((accordionStates.whomWorksForSoul) = $event))
    }, null, 8, ["matrix", "hasPremiumAccess", "modelValue"]),
    _createVNode(HealthMapAccordion, {
      matrix: __props.matrix,
      hasPremiumAccess: __props.userHasPremiumAccess,
      modelValue: accordionStates.healthMap,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((accordionStates.healthMap) = $event))
    }, null, 8, ["matrix", "hasPremiumAccess", "modelValue"]),
    _createVNode(ProgramsAccordion, {
      matrix: __props.matrix,
      hasPremiumAccess: __props.userHasPremiumAccess,
      modelValue: accordionStates.programs,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((accordionStates.programs) = $event))
    }, null, 8, ["matrix", "hasPremiumAccess", "modelValue"]),
    _createVNode(PredispositionToDiseasesAccordion, {
      matrix: __props.matrix,
      hasPremiumAccess: __props.userHasPremiumAccess,
      modelValue: accordionStates.predispositionToDiseases,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((accordionStates.predispositionToDiseases) = $event))
    }, null, 8, ["matrix", "hasPremiumAccess", "modelValue"]),
    _createVNode(EmptyModal, { show: waitApiCall.value }, null, 8, ["show"]),
    _createVNode(RequirePremiumModal, {
      show: showRequirePremiumModal.value,
      selectedDate: modalDate.value,
      onClose: _cache[23] || (_cache[23] = ($event: any) => (showRequirePremiumModal.value = false))
    }, null, 8, ["show", "selectedDate"])
  ]))
}
}

})